import { RefineClub } from '#src/searchCards/RefineClubs/index.tsx';
import { DailyFilter } from '#src/searchCards/index.ts';
import {
  MatchInfoGroup,
  PlayerGroup,
  ProjectionGroup,
  RefineTenGameAverageScore,
} from '#src/searchCards/nba/cardFilters.tsx';

const MAX_TEAM_LIMIT = 30;

export const scoutingCenterMarketFilters = [
  MatchInfoGroup,
  PlayerGroup({ withClub: true, withoutActiveClub: true }),
  ProjectionGroup(),
];

export const scoutingCenterMarketDropdownFilters = [
  RefineClub(MAX_TEAM_LIMIT),
  DailyFilter,
  RefineTenGameAverageScore,
];
